import { Helmet } from "react-helmet";
import { gql, useQuery } from "@apollo/client";
import Layout from "../../components/Layout";
import TabNavigation from "../../components/TabNavigation";
import ProfilePreview from "../../components/UserInterface/ProfilePreview";
import UserProfile from "../../components/User/UserProfile";
import styles from "./index.module.scss";

const GET_USER = gql`
  query User {
    me: self {
      first_name
      last_name
      adp_auth_num
      phone
      phone_ext
      locations {
        id
        name
        adp_auth_num
        address {
          address_1
          address_2
          city
          postal_code
          province
        }
      }
      organization {
        name
        address {
          name
          address_1
          address_2
          unit_number
          street_number
          street_name
          lot
          city
          postal_code
          province
        }
      }
      confirmed
      blocked
      email
      id
      username
      role {
        id
        description
        type
        name
      }
    }
  }
`;

const UserPage = () => {
  const { data, loading, error } = useQuery(GET_USER, {
    fetchPolicy: "no-cache",
  });

  return (
    <Layout>
      <Helmet>
        <title>Profile</title>
      </Helmet>
      <div className={styles.container}>
        {error && error.message}
        {loading ? (
          "loading..."
        ) : (
          <>
            <div className={styles.content}>
              <div className={styles.header}>
                <ProfilePreview
                  size="large"
                  user={data.me}
                  userRole
                  edit="Edit profile"
                  editTo="/profile/edit"
                />
              </div>
              <div className={styles.nav}>
                <TabNavigation
                  links={[
                    {
                      url: `/profile`,
                      text: "User Profile",
                    },
                  ]}
                />
              </div>
            </div>
            {data.me && <UserProfile user={data.me} />}
          </>
        )}
      </div>
    </Layout>
  );
};

export default UserPage;
